import img1 from "../student-work-images/5C81CA0A-F42C-4488-B9BB-46965BEAFD1A.jpg";
import img2 from "../student-work-images/0846AE5D-DACA-4E4E-9300-1061DEF8E9AF.jpg";
import img3 from "../student-work-images/44367A4B-F2E8-4043-9670-500A3696457B.jpg";
import img4 from "../student-work-images/9E7D8293-1D5A-4A72-AEAB-953E426E167C.jpg";
import img5 from "../student-work-images/C6C96A84-CF20-4E1A-A3FF-9A9741DB7A0B.jpg";
import img6 from "../student-work-images/IMG_2475 Large.jpeg";
import img7 from "../student-work-images/IMG_2824 Medium.jpeg";
import img8 from "../student-work-images/IMG_2827 Medium.jpeg";
import img9 from "../student-work-images/IMG_3086 Medium.jpeg";
import img10 from "../student-work-images/IMG_3088 Medium.jpeg";
import img11 from "../student-work-images/IMG_3094 Large.jpeg";
import img12 from "../student-work-images/IMG_3306 Medium.jpeg";
import img13 from "../student-work-images/IMG_3811 Large.jpeg";
import img14 from "../student-work-images/IMG_3868 Large.jpeg";
import img15 from "../student-work-images/IMG_3889 Large.jpeg";
import img16 from "../student-work-images/IMG_4110 Medium.jpeg";
import img17 from "../student-work-images/Background.png";
import img18 from "../student-work-images/IMG_001.jpeg";
import img19 from "../student-work-images/IMG_008.jpeg";
import img20 from "../student-work-images/IMG_011.jpeg";
import img21 from "../student-work-images/IMG_014.jpeg";
import img22 from "../student-work-images/IMG_015.jpeg";
import img23 from "../student-work-images/IMG_018.jpeg";
import img24 from "../student-work-images/IMG_031.jpeg";
import img25 from "../student-work-images/IMG_049.jpeg";
import img26 from "../student-work-images/IMG_4638 Large.jpeg";
import img27 from "../student-work-images/IMG_4644 Large.jpeg";
import img28 from "../student-work-images/IMG_4705 Large.jpeg";
import img29 from "../student-work-images/IMG_4715 Large.jpeg";
import img30 from "../student-work-images/IMG_4721 Large.jpeg";
import img31 from "../student-work-images/IMG_4722 Large.jpeg";
import img32 from "../student-work-images/IMG_4723 Large.jpeg";
import img33 from "../student-work-images/IMG_4725 Large.jpeg";
import img34 from "../student-work-images/IMG_4729 Large.jpeg";
import img35 from "../student-work-images/IMG_4734 Large.jpeg";
import img36 from "../student-work-images/IMG_4735 Large.jpeg";
import img37 from "../student-work-images/IMG_4766 Large.jpeg";
import img38 from "../student-work-images/IMG_4766 Large.jpg";
import img39 from "../student-work-images/IMG_4781 Large.jpeg";
import img40 from "../student-work-images/IMG_4787 Large.jpeg";
import img41 from "../student-work-images/IMG_4806 Large.jpeg";
import img42 from "../student-work-images/IMG_4808 Large.jpeg";
import img43 from "../student-work-images/IMG_4810 Large.jpeg";
import img44 from "../student-work-images/IMG_4813 Large.jpg";
import img45 from "../student-work-images/Dominic_Surico2.gif";
import img46 from "../student-work-images/Franco_Malvacedo.gif";
import img47 from "../student-work-images/harleen_vinyl.png";
import img48 from "../student-work-images/isabella_vinyl.jpg";
import img49 from "../student-work-images/m&M.jpg";
import img50 from "../student-work-images/Najair_Alam.gif";
import img51 from "../student-work-images/TJ Haggerty.gif";
import img52 from "../student-work-images/IMG_2053.jpeg";

export const getImages = () => [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18, img19, img20, img21, img22, img23, img24, img25, img26, img27, img28, img29, img30, img31, img32, img33, img34, img35,
    img36, img37, img38, img39, img40, img41, img42, img43, img44, img45, img46, img47, img48, img49, img50, img51, img52];